import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
  HttpHandler,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { inject } from '@angular/core';
import { AuthInterceptor as OidcAuthInterceptor } from 'angular-auth-oidc-client';
import { AuthService } from '../services/auth.service';
import { LOGIN_METHOD_KEY, LoginMethod } from '../enums/login-method.enum';

const identityAuthInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const authService = inject(AuthService);

  if (JSON.parse(req.headers.get('skipAuth') ?? 'false')) {
    return next(req);
  }

  const authToken = authService.identityUser()?.token;
  if (!authToken) {
    return throwError(() => new Error('Unauthorized'));
  }
  return next(
    req.clone({
      setHeaders: {
        Authorization: `Bearer ${authToken}`,
      },
    })
  ).pipe(
    catchError((err) => {
      if (err.status === 401) {
        const authToken = authService.identityUser()?.token;
        if (authToken) {
          return next(
            req.clone({
              setHeaders: {
                Authorization: `Bearer ${authToken}`,
              },
            })
          ).pipe(catchError((innerErr) => throwError(() => innerErr)));
        }
      }
      return throwError(() => err);
    })
  );
};

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const loginMethod = localStorage.getItem(LOGIN_METHOD_KEY);

  if (loginMethod === LoginMethod.IAM) {
    const oidcInterceptor = new OidcAuthInterceptor();
    const handler: HttpHandler = {
      handle: next,
    };
    return oidcInterceptor.intercept(req, handler);
  } else if (loginMethod === LoginMethod.Identity) {
    return identityAuthInterceptor(req, next);
  } else {
    return next(req);
  }
};
